import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, requireAuth = true, allowUnauthenticated = false, allowAuthenticated = false }) => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-slate-900 via-gray-900 to-zinc-900 flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-400"></div>
            </div>
        );
    }

    if (requireAuth && !isAuthenticated) {
        if (allowUnauthenticated) {
            return children;
        }
        return <Navigate to="/login" replace />;
    }

    if (!requireAuth && isAuthenticated && !allowAuthenticated) {
        return <Navigate to="/profile" replace />;
    }

    return children;
};

export default ProtectedRoute;
